import * as React from 'react';
export const VISvg = React.forwardRef(function VISvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      fill: '#EAEEF3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 3h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1Z',
      fill: '#F6F9FC',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.4 3.93 9.93 5.09a.26.26 0 0 0-.18.24v2.32c0 .23.28.35.45.19l3.47-3.48c.2-.2 0-.52-.27-.43Zm-10.8 0 3.47 1.16c.1.03.18.13.18.24v2.32c0 .23-.28.35-.45.19L2.33 4.36c-.2-.2 0-.52.27-.43Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('circle', {
      cx: 8,
      cy: 5,
      r: 1,
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.16 11.59 8.19 9.23a.25.25 0 0 0-.38 0l-1.97 2.36a.25.25 0 0 0 .2.41h3.93c.2 0 .32-.25.19-.41Z',
      fill: '#FCD669',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 6a3 3 0 0 0 2 0 3 3 0 0 0 2 0v1.5H6V6Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6 7.5c0 1.5 1.5 2.8 2 3 .5-.2 2-1.5 2-3H6Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M2 6h2v4H2V6Zm10 0h2v4h-2V6Z',
      fill: '#45B2E8',
    }),
  );
});
VISvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var VI = {
  category: 'flag',
  colorable: false,
  name: 'VI',
  svg: VISvg,
};
